<template>
  <ValidationObserver ref="form" #default="{ dirty, valid }">
    <main class="content">
      <div class="content__heading content__heading--navigation">
        <h1>
          <i class="icon--list"></i> {{ $t('fusebox.listTitle') }}
          <small v-if="fuseboxList !== 'undefined'">({{ $store.getters['fusebox/total'] }})</small>
        </h1>

        <nav class="navigation--buttonGroup">
          <button @click="showModal" class="navigation--buttonGroup__text">
            <i class="icon--plus"></i>&nbsp;
            <span class="hide--mobile"> {{ $t('fusebox.add') }}</span>
            <span class="show--mobile"> {{ $t('general.create') }}</span>

          </button>
        </nav>
      </div>

      <section class="content--boxed">
        <!--        <div class="flex">-->
        <!--          <div v-if="$can('request_access', 'plans')" class="input input&#45;&#45;shared">-->
        <!--            <input-->
        <!--              type="checkbox" class="inp-cbx"-->
        <!--              id="cbx" style="display: none;"-->
        <!--              v-model="filterShared"-->
        <!--            />-->
        <!--            <label class="cbx" for="cbx">-->
        <!--                <span>-->
        <!--                  <svg width="12px" height="10px" viewbox="0 0 12 10">-->
        <!--                    <polyline points="1.5 6 4.5 9 10.5 1"></polyline>-->
        <!--                  </svg>-->
        <!--                </span>-->
        <!--              <span>{{ $t('fusebox.shared') }}</span>-->
        <!--            </label>-->
        <!--          </div>-->

        <input :placeholder="$t('search.fuseboxes')" type="text" name="search" v-model="search" :required="false"
               class="input input--search"/>
        <!--        </div>-->

        <div class="table table--badged" v-if="fuseboxList.length > 0">

          <div class="table--badged__row table--badged__row--clickable" v-for="fusebox in fuseboxList"
               :key="fusebox.uuid" @click=show(fusebox.uuid)>

            <div class="table--badged__badge table--badged__badge--light"
                 :class="{'table--badged__badge--shared': (fusebox.shared && $can('request_access', 'plans'))}">
              <i :class="[(fusebox.shared && $can('request_access', 'plans')) ? 'icon--link' : 'icon--list']"></i>
            </div>

            <div class="table--badged__description">
              <h3>
                {{ fusebox.name }} <small v-if="fusebox.location.name">
                ({{ fusebox.location.name }})</small>
              </h3>
              <small>
                <span class="table--badged__description__item" v-if="fusebox.location.updated_at !== 'undefined'"><i
                  class="icon--calendar"></i> {{ fusebox.updated_at | moment('MMM D YYYY, HH:mm') }}</span>
                <span class="table--badged__description__item" v-if="fusebox.location.address !== 'undefined'"><i
                  class="icon--location"></i> {{ [[fusebox.location.address, fusebox.location.no].join(' '), fusebox.location.city].join(', ') }}</span>
              </small>
            </div>
            <div class="navigation--buttonGroup navigation--buttonGroup--table">
              <button @click.stop="downloadPdf(fusebox)"><i class="icon--pdf"></i></button>
              <button @click.stop="prepEdit(fusebox)"><i class="icon--edit"></i></button>
              <button v-if="(fusebox.shared && isRole(roles.OWNER.ROLE_OWNER) || !fusebox.shared)"
                      @click.stop="$modal.show('confirmation', { id:  fusebox.uuid})"><i class="icon--delete"></i>
              </button>
              <button v-if="$can('request_access', 'plans') && fusebox.shared"
                      @click.stop="$modal.show('revoke-confirmation', { fusebox:  fusebox.uuid})"><i
                class="icon--unlink"></i>
              </button>
            </div>

          </div>

        </div>
        <template v-if="total === 0">
          <div class="message" v-if="!isFilterApplied">
            {{ $t('messages.noFuseboxes') }}
          </div>
          <div class="message" v-else>
            {{ $t('messages.noResults') }}
          </div>
        </template>
      </section>

      <DqPaginate v-if="lastPage > 1" v-model="page" :per="2" :page-count="lastPage"
                  :click-handler="dispatchList"/>
      <AddFusebox @hideModal="hideModal" :edit="edit" @clearEdit="clearEdit" @init="init"/>
      <Confirm @confirmed="remove"/>
      <Confirm name="revoke-confirmation" action-key="general.revoke" @confirmed="revokeAccess"
               title="general.revoke_title" body="general.revoke_body_company"/>
    </main>
  </ValidationObserver>

</template>

<script>
import _debounce from 'lodash.debounce'
import AddFusebox from '@/components/Modal/AddFusebox'
import { errHandler } from '@/helpers'
import DqPaginate from '@/components/Parts/DqPaginate'
import Confirm from '@/components/Modal/Confirm'
import { mapGetters } from 'vuex'

export default {
  name: 'Fusebox-Index',
  components: {
    Confirm,
    DqPaginate,
    AddFusebox
  },
  beforeMount () {
    this.$store.commit('loader/startIntLoading')
  },
  async mounted () {
    await this.$store.dispatch('fusebox/resetFilters')
    this.init(true)
    this.debouncedSearch = _debounce(async () => {
      await this.$store.dispatch('fusebox/resetPage', { resetPage: true })
      this.dispatchList()
    }, 200)
  },
  data: () => {
    return {
      edit: false,
      submit: false,
      columns: [
        {
          label: 'general.name',
          key: 'name',
          sortable: true
        },
        {
          label: 'fusebox.form.labels',
          key: 'labels',
          sortable: true,
          htmlContent: true
        },
        {
          label: 'general.actions',
          key: 'actions',
          sortable: true,
          htmlContent: true
        }
      ]
    }
  },
  computed: {
    ...mapGetters('fusebox', ['fuseboxList', 'lastPage', 'total', 'isFilterApplied']),
    search: {
      get () {
        return this.$store.getters['fusebox/search']
      },
      set (value) {
        this.$store.commit('fusebox/setSearch', value)
      }
    },
    filterShared: {
      get () {
        return this.$store.getters['fusebox/shared']
      },
      set (value) {
        this.$store.commit('fusebox/setShared', value)
      }
    },
    filterLabel: {
      get () {
        return this.$store.getters['fusebox/label']
      },
      set (value) {
        this.$store.commit('fusebox/setLabel', value)
      }
    },
    page: {
      get () {
        return this.$store.getters['fusebox/currentPage']
      },
      set (value) {
        this.$store.commit('fusebox/setPage', value)
      }
    }
  },
  methods: {
    clearEdit () {
      this.edit = false
    },
    prepEdit (item) {
      this.edit = item
      this.showModal()
    },
    async init (resetPage = false) {
      try {
        await this.$store.dispatch('fusebox/resetPage', { resetPage })
        this.dispatchList()
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      }
    },
    async dispatchList () {
      try {
        await this.$store.dispatch('fusebox/get')
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      } finally {
        this.$store.dispatch('loader/stopIntLoading')
      }
    },
    showModal () {
      this.$modal.show('Fusebox-Group')
    },
    hideModal () {
      this.$modal.hide('Fusebox-Group')
    },
    filterByLabel (label) {
      this.filterLabel = this.filterLabel === label ? '' : label
    },
    async remove ({ id }) {
      if (this.submit) { return false }
      try {
        this.submit = true
        await this.$store.dispatch('fusebox/delete', id)
        this.init()
        this.$toasted.global.success_message({
          message: this.$t('fusebox.deleteSuccess')
        })
        this.$modal.hide('confirmation')
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      } finally {
        this.submit = false
      }
    },
    async revokeAccess (params) {
      try {
        await this.$store.dispatch('fusebox/revokeAccess', params)
        this.$toasted.global.success_message({
          message: this.$t('general.accessRevoked')
        })
        this.init()
        this.$modal.hide('revoke-confirmation')
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      }
    },
    show (id) {
      this.$router.push({ name: 'fusebox.single.index', params: { id: id } })
    },
    async downloadPdf (fusebox) {
      try {
        const data = await this.$store.dispatch('fusebox/pdfGenerate', fusebox.qr_code)
        const url = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${fusebox.name}.pdf`)
        document.body.appendChild(link)
        link.click()
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      }
    }
  },
  watch: {
    search () {
      this.debouncedSearch()
    },
    filterLabel () {
      this.init(true)
    },
    filterShared () {
      this.init(true)
    }
  }
}
</script>
